import { useMutation } from '@apollo/react-hooks';
import { useCallback, useMemo } from 'react';
import {
  AddressQueryVariables,
  RestAddressAttributesData,
  createShippingAddressError
} from '../fragments.rest';
import { updateAddressesCache as update } from '../useAddressesQuery/useAddressesQuery.rest';
import { createAddressRestObject } from '../createAddressRestObject';
import { CREATE_ADDRESS_MUTATION, CreateAddressMutation } from './useCreateAddressMutation.rest';

export const useCreateAddressMutation = () => {
  const [mutate, { loading, error }] = useMutation<CreateAddressMutation, AddressQueryVariables>(
    CREATE_ADDRESS_MUTATION,
    {
      update
    }
  );

  const createAddress = useCallback(
    async (address: RestAddressAttributesData) => {
      const result = await mutate(createAddressRestObject(address));
      return result.data?.createAddress.data;
    },
    [mutate]
  );

  const parsedError = useMemo(() => createShippingAddressError(error), [error]);

  return [createAddress, { loading, error: parsedError }] as const;
};
